// extracted by mini-css-extract-plugin
export default {"wrapper":"Ac","star":"Bc","emptyStar":"Cc","filledStar":"Dc","filledStarSvg":"Ec"};